var app = angular.module('leonardo');

var WidgetRadios = function(FilterService, $timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/radios.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      inline: '@',
      options: '=',
      name:'@',
      mode:'@',
      filter: '@',
      ngChange: '&'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.options_valid = [];

      scope.ngModelCtrl.$render = function() {
        if (scope.filter) {
          scope.ngModelCtrl.$setViewValue(FilterService.getFilter(scope.filter));
        }
        scope.value = scope.ngModelCtrl.$modelValue;
      };

      scope.initOptions = function () {
        var options = [];
        if (scope.mode === 'array'){
          angular.forEach(scope.options, function(value, key){
            options.push({id: key, name: value});
          });
        }
        else if (scope.mode === 'score'){
          angular.forEach(scope.options, function(value){
            options.push({id: value.value, name: value.value});
          });
        }
        else {
          options = angular.copy(scope.options);
        }
        scope.options_valid = options;
      };

      scope.toggle = function(value) {
        if (scope.disabled) {
          return;
        }
        scope.value = value;
      };

      scope.$watch('value', function (value) {
        if (scope.filter) {
          FilterService.setFilter(scope.filter, value);
        }
        scope.ngModelCtrl.$setViewValue(value);
        scope.ngChange();
      });

      scope.$watch('options', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.initOptions();
        }
      });

      $timeout(function() {
        scope.initOptions();
      }, 10);

    }
  };
};

app.directive('widgetRadios', ['FilterService', '$timeout', WidgetRadios]);
